export default class FileModelEvent { }

FileModelEvent.FILE_ADDED = 'FileModelEvent.FILE_ADDED';
FileModelEvent.FILE_REMOVED = 'FileModelEvent.FILE_REMOVED';
FileModelEvent.FILE_SEEN = 'FileModelEvent.FILE_SEEN';